import authenticationSevice from '../../services/membership/Identity.service';
import { AppThunkAction } from '..';

export enum UserActionTypes {
  LOGIN_REQUEST = 'LOGIN_REQUEST',
  LOGIN_ERROR = 'LOGIN_ERROR',
  LOGIN_JWT_Receive = 'LOGIN_JWT_Receive',
  LOGOUT = 'LOGOUT',
}
export interface ILoginAction {
  type: UserActionTypes.LOGIN_REQUEST;
  username: string;
}
export interface ILoginErrorAction {
  type: UserActionTypes.LOGIN_ERROR;
  message: string;
}
export interface ILoginReceiveAction {
  type: UserActionTypes.LOGIN_JWT_Receive;
}
export interface ILogOutAction {
  type: UserActionTypes.LOGOUT;
}
export type UserActions = ILoginAction | ILoginErrorAction | ILoginReceiveAction | ILogOutAction;

export const actionCreators = {
  login:
    (pUsername: string, password: string): AppThunkAction<UserActions> =>
    async (dispatch, getState) => {
      // Only load data if it's something we don't already have (and are not already loading)
      dispatch({ type: UserActionTypes.LOGIN_REQUEST, username: pUsername });
      try {
        const res = await authenticationSevice.login(pUsername, password, '', '', '');
        if (res.status !== 200) {
          dispatch({ type: UserActionTypes.LOGIN_ERROR, message: pUsername });
          return;
        }

        dispatch({ type: UserActionTypes.LOGIN_JWT_Receive });
      } catch (ex) {
        const err = ex as any;

        dispatch({ type: UserActionTypes.LOGIN_ERROR, message: err.message });
      }
    },
  loginErrorAction:
    (messageValue: string): AppThunkAction<UserActions> =>
    async (dispatch, getState) => {
      dispatch({ type: UserActionTypes.LOGIN_ERROR, message: messageValue });
    },
  loginSuccessAction:
    (jwtParam): AppThunkAction<UserActions> =>
    async (dispatch, getState) => {
      await dispatch({ type: UserActionTypes.LOGIN_JWT_Receive });
    },
  loginRequestAction:
    (usernameValue: string): AppThunkAction<UserActions> =>
    async (dispatch, getState) => {
      await dispatch({ type: UserActionTypes.LOGIN_REQUEST, username: usernameValue });
    },
  logoutAction: (): AppThunkAction<UserActions> => async (dispatch) => {
    await dispatch({ type: UserActionTypes.LOGOUT });
  },
};
